import { ApplicationProvider } from "@ui-kitten/components";
import React from "react";
import * as eva from "@eva-design/eva";
import { NavigationContainer } from "@react-navigation/native";
import { ToastContainer } from "react-toastify";
import theme from "./theme.json";
import mapToArray from "./helpers/mapToArray";
import AppNavigator, { linkingConfig } from "./navigators/AppNavigator";
import initialFirebase from "./helpers/initalFirebase";
import { AuthContextProvider } from "./context/AuthContext";
import LoadingScreen from "./screens/LoadingScreen";
import LanguageSpinner from "./components/LanguageSpinner";

const config = {
    screens: {
        ...linkingConfig,
    },
};
const linking = {
    prefixes: mapToArray(process.env.BASE_DOMAINS as string),
    config,
};

initialFirebase();
function App() {
    return (
        <ApplicationProvider {...eva} theme={{ ...eva.light, ...theme }}>
            <AuthContextProvider>
                <NavigationContainer
                    linking={linking}
                    fallback={<LoadingScreen />}
                >
                    <LanguageSpinner />
                    <AppNavigator />
                </NavigationContainer>
            </AuthContextProvider>
            <ToastContainer position="top-center" hideProgressBar />
        </ApplicationProvider>
    );
}

export default App;
